import api from './api.ts';

export async function getCourses() {
  try {
    const res = await api.get('/data/CourseCards.json');
    return { data: res.data, error: null };
  } catch (error) {
    return { data: null, error: 'Failed to fetch course cards' };
  }
}

export async function getChapterData(chapterType) {
  try {
    const res = await api.get(`/data/${chapterType}Data.json`);
    return { data: res.data, error: null };
  } catch (error) {
    return { data: null, error: 'Failed to fetch chapter data' };
  }
}

export async function getStudentSections() {
  try {
    const res = await api.get('/data/student_sections.json');
    return { data: res.data, error: null };
  } catch (error) {
    return { data: null, error: 'Failed to fetch student sections' };
  }
}

export async function getTestData() {
  try {
    const res = await api.get('/data/test.json');
    return { data: res.data, error: null };
  } catch (error) {
    return { data: null, error: 'Failed to fetch test data' };
  }
}

export async function getContentPage(courseType, sectionIndex) {
  const Domain = process.env.REACT_APP_CONTENT_API_URL;
  try {
    const chaptersRes = await api.get('/api/chapters', { baseURL: Domain });
    const chapters = chaptersRes.data.items;

    const chapterIds = chapters
      .filter(chap => chap.course_type === courseType)
      .map(chap => chap.id);

    const sectionsRes = await api.get('/api/sections', { baseURL: Domain });
    const sections = sectionsRes.data.items;
    
    const filteredSections = sections.filter(sec => chapterIds.includes(sec.chapter_id));
    const section = filteredSections.find(sec => sec.section_index === sectionIndex);

    if (!section || !Array.isArray(section.json)) {
      return { data: null, error: 'Section or slides not found' };
    }
    return { data: section.json, error: null };
  } catch (error) {
    return { data: null, error: 'Failed to fetch section slides' };
  }
}

export async function getContentPageFromRouter(courseType, sectionIndex) {
  try {
    const res = await api.get(`/content/${courseType}/${sectionIndex}`);
    return { data: res.data, error: null };
  } catch (error) {
    console.error('Failed to fetch content from router:', error);
    return { data: null, error: 'Failed to fetch content from router' };
  }
}